import { render, staticRenderFns } from "./textAddon.vue?vue&type=template&id=e65da630&scoped=true&"
import script from "./textAddon.vue?vue&type=script&lang=js&"
export * from "./textAddon.vue?vue&type=script&lang=js&"
import style0 from "./textAddon.vue?vue&type=style&index=0&id=e65da630&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65da630",
  null
  
)

export default component.exports